import React, { useEffect, useState } from "react"
import Style from "./index.module.scss"

const Collapsible = props => {
  const { title, children, isOpenAccordian } = props
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = () => {
    setIsOpen(!isOpen)
  }
  useEffect(() => {
    setIsOpen(isOpenAccordian)
  }, [isOpenAccordian])
  return (
    <div className={Style.Collapsible}>
      <div className={`header ${isOpen ? "open" : ""}`} onClick={handleClick}>
        {title}
      </div>
      {isOpen ? <div className="body">{children}</div> : null}
    </div>
  )
}

export default Collapsible
